import { useEffect } from 'react';

/**
 * A react hook to call the given handler function when the user clicks
 * outside the given element.
 *
 * @param ref reference to the html element
 * @param handler function to be called when the user clicks outside the element
 */
function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: () => void,
  ignoreRef?: React.RefObject<HTMLElement>,
) {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      if (
        !ref.current ||
        ref.current.contains(event.target as Node) ||
        (ignoreRef &&
          ignoreRef.current &&
          ignoreRef.current.contains(event.target as Node))
      ) {
        return;
      }
      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener(
      'touchstart',
      listener as EventListenerOrEventListenerObject,
    );

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener(
        'touchstart',
        listener as EventListenerOrEventListenerObject,
      );
    };
  }, [ref, handler, ignoreRef]);
}

export default useOnClickOutside;
